import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { useCommonStyles } from './styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  gradesContainer: {
    width: '800px',

    '& .grade-radio': {
      color: (props) => (props.mode === 'dark' ? '#4C4D61' : '#DEDEDE'),
    },
    '& > .grade': {
      width: '100%',
      borderRadius: 8,
      border: (props) =>
        `1px solid ${props.mode === 'dark' ? '#282A4A' : '#F1F1F1'}`,
      background: (props) => (props.mode === 'dark' ? '#202133' : '#FFF'),
      marginBottom: 24,
      borderLeftWidth: '10px !important',
    },

    '& .grade-wrapper': {
      display: 'flex',

      '& .grade-circle': {
        width: 24,
        height: 24,
        borderRadius: '100%',
        marginRight: 10,
      },
    },
  },
  currentGradeContainer: {
    display: 'flex',
    padding: '16px 16px 16px 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,

    '& > .currentGrade': {
      display: 'flex',
      alignItems: 'center',

      '& > .currentGradeText': {
        marginRight: 24,
        color: (props) => (props.mode === 'dark' ? '#FFF' : '#252525'),
      },
    },
  },
  dialogActionsContainer: {
    padding: '0 24px 24px',
    background: (props) => (props.mode === 'dark' ? '#202133' : '#FFF'),

    '& > .bttn': {
      marginLeft: 24,

      '&.cancel': {
        background: 'transparent',
        color: (props) => (props.mode === 'dark' ? '#FFF' : '#000'),
      },
      '&.save': {
        background: (props) => (props.mode === 'dark' ? '#FFF' : '#000'),
        color: (props) => (props.mode === 'dark' ? '#000' : '#FFF'),
      },
    },
  },
}));

const GRADE_COLORS_MAP = {
  A: '#00CC66',
  B: '#33CCFF',
  C: '#FFCC00',
  D: '#FF6600',
  E: '#FF0000',
  F: '#808080',
};

const GRADE_MAP = ['A', 'B', 'C', 'D', 'E', 'F'];

const MatchingDetailsEditGrade = ({
  title = '',
  isOpen = false,
  handleClose,
  CurrentGrade,
  grade,
  upgradeOverallGrade,
  mode,
}) => {
  const classes = useStyles({ mode });
  const commonClasses = useCommonStyles({ mode });
  const [selectedGrade, setSelectedGrade] = useState(grade);

  const handleOnSave = async () => {
    upgradeOverallGrade(selectedGrade);
    handleClose();
  };

  return (
    <Dialog
      maxWidth={'lg'}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        style={{ background: mode === 'dark' ? '#202133' : '#FFF' }}
      >
        <Typography classes={{ root: commonClasses.fontMediumBold }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent
        dividers
        style={{
          background: mode === 'dark' ? '#202133' : '#FFF',
          borderBottom: 0,
        }}
      >
        <div className={classes.currentGradeContainer}>
          <Typography classes={{ root: commonClasses.fontMediumBold }}>
            Select Match Grade from below:
          </Typography>
          <div className="currentGrade">
            <Typography
              classes={{
                root: clsx(commonClasses.fontMedium, 'currentGradeText'),
              }}
            >
              Current Grade:
            </Typography>
            {CurrentGrade}
          </div>
        </div>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="grade"
            name="grade"
            value={selectedGrade}
            onChange={(e) => setSelectedGrade(e.target.value)}
            className={classes.gradesContainer}
          >
            {GRADE_MAP.map((grade) => (
              <FormControlLabel
                value={grade}
                control={<Radio className="grade-radio" />}
                className={clsx('grade', `grade-${grade}`)}
                label={
                  <div className="grade-wrapper">
                    <div
                      className="grade-circle"
                      style={{ backgroundColor: GRADE_COLORS_MAP[grade] }}
                    />
                    <Typography
                      classes={{ root: commonClasses.fontMediumBold }}
                      style={{ lineHeight: '24px' }}
                    >
                      {grade}
                    </Typography>
                  </div>
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActionsContainer }}>
        <Button
          onClick={handleClose}
          className="bttn cancel"
          variant="outlined"
        >
          Cancel
        </Button>

        <Button
          onClick={handleOnSave}
          className="bttn save"
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MatchingDetailsEditGrade;
